document.addEventListener("DOMContentLoaded", function () {

  const builder = document.querySelector("[data-combo-builder]");
  if (!builder) return;

  let comboLimit    = 0;
  let selectedItems = {};

  const step1 = document.querySelector(".combo-step-1");
  const step2 = document.querySelector(".combo-step-2");

  const countEl            = document.getElementById("selected-count");
  const limitEl            = document.getElementById("combo-limit");
  const progressFill       = document.getElementById("combo-progress-fill");
  const progressPercent    = document.getElementById("progress-percent");
  const selectedProductsEl = document.getElementById("selected-products");
  const remainingItemsEl   = document.getElementById("remaining-items");
  const addCartBtn         = document.getElementById("add-combo-cart");

  const ROWS_PER_PAGE = 5;

  const allProductsCache   = {};
  const originalOrderCache = {};
  const currentPageMap     = {};

  /* ======================
     RESPONSIVE COLUMNS
  ====================== */

  function getColumnsPerRow() {
    const width = window.innerWidth;
    if (width <= 480)  return 2;
    if (width <= 768)  return 2;
    if (width <= 1024) return 3;
    return 4;
  }

  function getItemsPerPage() {
    return getColumnsPerRow() * ROWS_PER_PAGE;
  }

  /* ======================
     COMBO SELECTION
  ====================== */

  document.querySelectorAll(".combo-select").forEach(button => {

    button.addEventListener("click", async function () {

      document.querySelectorAll(".combo-select")
        .forEach(btn => btn.classList.remove("active"));

      this.classList.add("active");

      comboLimit = parseInt(this.dataset.size);
      limitEl.textContent = comboLimit;

      step1.style.display = "none";
      step2.style.display = "block";

      document.getElementById("step-1")
        .classList.add("completed");

      document.getElementById("step-2-indicator")
        .classList.add("active");

      const firstTab = document.querySelector(".combo-tab.active");

      if (firstTab) {

        const firstContent = document.querySelector(
          `[data-content="${firstTab.dataset.tab}"]`
        );

        if (firstContent && !firstContent.dataset.loaded) {
          await loadProducts(firstContent);
          firstContent.dataset.loaded = "true";
        }

      }

      updateSummary();

    });

  });

  /* ======================
     TABS
  ====================== */

  document.querySelectorAll(".combo-tab").forEach(tab => {

    tab.addEventListener("click", async function () {

      const target = this.dataset.tab;

      document.querySelectorAll(".combo-tab")
        .forEach(btn => btn.classList.remove("active"));

      document.querySelectorAll(".combo-tab-content")
        .forEach(content => content.classList.remove("active"));

      this.classList.add("active");

      const activeContent = document.querySelector(
        `[data-content="${target}"]`
      );

      if (activeContent) {

        activeContent.classList.add("active");

        if (!activeContent.dataset.loaded) {
          await loadProducts(activeContent);
          activeContent.dataset.loaded = "true";
        }

      }

    });

  });

  /* ======================
     AJAX PRODUCT LOAD
  ====================== */

  async function loadProducts(tabContent) {

    const handle    = tabContent.dataset.handle;
    const container = tabContent.querySelector(".combo-products");

    if (!handle || !container) return;

    if (allProductsCache[handle]) {
      currentPageMap[handle] = 1;
      renderPage(tabContent, handle, 1);
      return;
    }

    container.innerHTML = "<p>Loading products...</p>";

    try {

      const response = await fetch(
        `/collections/${handle}/products.json?limit=250`
      );

      const data = await response.json();

      allProductsCache[handle]   = [...data.products];
      originalOrderCache[handle] = [...data.products];
      currentPageMap[handle]     = 1;

      renderPage(tabContent, handle, 1);

    } catch (error) {

      console.error(error);
      container.innerHTML = "<p>Unable to load products.</p>";

    }

  }

  /* ======================
     RENDER ONE PAGE
  ====================== */

  function renderPage(tabContent, handle, page) {

    const container = tabContent.querySelector(".combo-products");
    if (!container) return;

    const ITEMS_PER_PAGE = getItemsPerPage();

    const allProducts = allProductsCache[handle] || [];
    const totalPages  = Math.ceil(allProducts.length / ITEMS_PER_PAGE);
    const start       = (page - 1) * ITEMS_PER_PAGE;
    const pageItems   = allProducts.slice(start, start + ITEMS_PER_PAGE);

    container.innerHTML = "";

    pageItems.forEach((product, index) => {

      const globalIndex = start + index;
      const variant     = product.variants[0];

      let image = "";

      if (product.images && product.images.length) {
        const firstImage = product.images[0];
        image = firstImage.src || firstImage.url || "";
      }

      const savedQty = selectedItems[variant.id]
        ? selectedItems[variant.id].qty
        : 0;

      container.insertAdjacentHTML("beforeend", `
        <div
          class="combo-product"
          data-index="${globalIndex}"
          data-variant="${variant.id}"
          data-title="${product.title}"
          data-price="${variant.price}"
        >
          <div class="combo-product-image">
            <img src="${image}" alt="${product.title}">
          </div>
          <h4>${product.title}</h4>
          <div class="combo-price">₹${variant.price}</div>
          <div class="qty-box">
            <button type="button" class="qty-minus">-</button>
            <input type="number" value="${savedQty}" min="0" class="qty-input">
            <button type="button" class="qty-plus">+</button>
          </div>
        </div>
      `);

    });

    attachQuantityEvents(container);

    // Remove old pagination
    const existingPagination = tabContent.querySelector(".combo-pagination");
    if (existingPagination) existingPagination.remove();

    if (totalPages <= 1) return;

    tabContent.insertAdjacentHTML(
      "beforeend",
      buildPagination(page, totalPages)
    );

    tabContent.querySelectorAll(".combo-page-btn").forEach(btn => {

      btn.addEventListener("click", function () {

        const goTo = parseInt(this.dataset.page);
        if (isNaN(goTo)) return;

        currentPageMap[handle] = goTo;
        renderPage(tabContent, handle, goTo);

        tabContent.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });

      });

    });

  }

  /* ======================
     BUILD PAGINATION HTML
  ====================== */

  function buildPagination(currentPage, totalPages) {

    let buttons = "";

    // Prev button
    buttons += `
      <button
        class="combo-page-btn combo-page-prev ${currentPage === 1 ? "disabled" : ""}"
        data-page="${currentPage - 1}"
        ${currentPage === 1 ? "disabled" : ""}
      >&#8592;</button>
    `;

    const windowSize = 5;
    let startPage = Math.max(1, currentPage - Math.floor(windowSize / 2));
    let endPage   = startPage + windowSize - 1;

    if (endPage > totalPages) {
      endPage   = totalPages;
      startPage = Math.max(1, endPage - windowSize + 1);
    }

    if (startPage > 1) {
      buttons += `<button class="combo-page-btn" data-page="1">1</button>`;
      if (startPage > 2) {
        buttons += `<span class="combo-page-ellipsis">…</span>`;
      }
    }

    for (let p = startPage; p <= endPage; p++) {
      buttons += `
        <button
          class="combo-page-btn ${p === currentPage ? "active" : ""}"
          data-page="${p}"
        >${p}</button>
      `;
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        buttons += `<span class="combo-page-ellipsis">…</span>`;
      }
      buttons += `
        <button class="combo-page-btn" data-page="${totalPages}">
          ${totalPages}
        </button>
      `;
    }

    // Next button
    buttons += `
      <button
        class="combo-page-btn combo-page-next ${currentPage === totalPages ? "disabled" : ""}"
        data-page="${currentPage + 1}"
        ${currentPage === totalPages ? "disabled" : ""}
      >&#8594;</button>
    `;

    return `<div class="combo-pagination">${buttons}</div>`;

  }

  /* ======================
     QUANTITY EVENTS
  ====================== */

  function attachQuantityEvents(parent) {

    parent.querySelectorAll(".combo-product").forEach(product => {

      const variantId = product.dataset.variant;
      const qtyInput  = product.querySelector(".qty-input");
      const plusBtn   = product.querySelector(".qty-plus");
      const minusBtn  = product.querySelector(".qty-minus");

      plusBtn.addEventListener("click", () => {

        if (comboLimit === 0) {
          alert("Please select a combo first");
          return;
        }

        if (getTotalQty() >= comboLimit) {
          alert(`Maximum ${comboLimit} items allowed`);
          return;
        }

        qtyInput.value = parseInt(qtyInput.value) + 1;
        updateProduct(variantId, product);

      });

      minusBtn.addEventListener("click", () => {

        if (parseInt(qtyInput.value) <= 0) return;

        qtyInput.value = parseInt(qtyInput.value) - 1;
        updateProduct(variantId, product);

      });

    });

  }

  /* ======================
     UPDATE PRODUCT
  ====================== */

  function updateProduct(variantId, product) {

    const qty   = parseInt(product.querySelector(".qty-input").value);
    const title = product.querySelector("h4").innerText;

    if (qty > 0) {
      selectedItems[variantId] = { qty, title };
    } else {
      delete selectedItems[variantId];
    }

    updateSummary();

  }

  /* ======================
     TOTAL QTY
  ====================== */

  function getTotalQty() {

    let total = 0;
    Object.values(selectedItems).forEach(item => { total += item.qty; });
    return total;

  }

  /* ======================
     SUMMARY
  ====================== */

  function updateSummary() {

    const total = getTotalQty();

    countEl.textContent = total;

    let percent = 0;
    if (comboLimit > 0) {
      percent = Math.round((total / comboLimit) * 100);
    }

    progressFill.style.width    = percent + "%";
    progressPercent.textContent = percent + "%";

    const remaining = comboLimit - total;

    if (comboLimit === 0) {
      remainingItemsEl.innerHTML = "Choose a combo first";
    } else if (remaining > 0) {
      remainingItemsEl.innerHTML =
        `Select ${remaining} more item${remaining > 1 ? "s" : ""}`;
    } else {
      remainingItemsEl.innerHTML = "✓ Combo Complete";
    }

    selectedProductsEl.innerHTML = "";

    Object.values(selectedItems).forEach(item => {
      selectedProductsEl.innerHTML += `
        <div class="summary-item">
          <span>${item.title}</span>
          <strong>x${item.qty}</strong>
        </div>
      `;
    });

    addCartBtn.disabled = total !== comboLimit;

  }

  /* ======================
     ADD TO CART
  ====================== */

  addCartBtn.addEventListener("click", async function () {

    const items = [];

    Object.keys(selectedItems).forEach(id => {
      items.push({
        id:       parseInt(id),
        quantity: selectedItems[id].qty
      });
    });

    if (!items.length) return;

    try {

      await fetch("/cart/add.js", {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify({ items })
      });

      window.location.href = "/cart";

    } catch (error) {
      alert("Unable to add products.");
    }

  });

  /* ======================
     SORT DROPDOWN
  ====================== */

  document.addEventListener("click", function (e) {

    const trigger = e.target.closest(".combo-sort-trigger");

    if (trigger) {

      const dropdown = trigger.closest(".combo-sort-dropdown");

      // Close all other dropdowns
      document.querySelectorAll(".combo-sort-dropdown").forEach(d => {
        if (d !== dropdown) d.classList.remove("open");
      });

      dropdown.classList.toggle("open");
      return;

    }

    // Click outside closes all
    if (!e.target.closest(".combo-sort-dropdown")) {
      document.querySelectorAll(".combo-sort-dropdown").forEach(d => {
        d.classList.remove("open");
      });
    }

  });

  /* ======================
     SORT PRODUCTS
  ====================== */

  document.addEventListener("click", function (e) {

    if (!e.target.classList.contains("combo-sort-option")) return;

    const clickedOption = e.target;
    const dropdown      = clickedOption.closest(".combo-sort-dropdown");
    const tabContent    = dropdown.closest(".combo-tab-content");

    if (!tabContent) return;

    const handle = tabContent.dataset.handle;
    if (!handle || !allProductsCache[handle]) return;

    const sortType = clickedOption.dataset.sort;

    // Mark selected option in this dropdown only
    dropdown.querySelectorAll(".combo-sort-option").forEach(o => {
      o.classList.remove("selected");
    });

    clickedOption.classList.add("selected");

    // Update trigger label for this tab
    const currentSortLabel = dropdown.querySelector(".current-sort");
    if (currentSortLabel) {
      currentSortLabel.textContent = clickedOption.textContent.trim();
    }

    // Sort the cached array
    switch (sortType) {

      case "featured":
        allProductsCache[handle] = [...originalOrderCache[handle]];
        break;

      case "az":
        allProductsCache[handle].sort((a, b) =>
          a.title.localeCompare(b.title)
        );
        break;

      case "za":
        allProductsCache[handle].sort((a, b) =>
          b.title.localeCompare(a.title)
        );
        break;

      case "price-low":
        allProductsCache[handle].sort((a, b) =>
          parseFloat(a.variants[0].price) - parseFloat(b.variants[0].price)
        );
        break;

      case "price-high":
        allProductsCache[handle].sort((a, b) =>
          parseFloat(b.variants[0].price) - parseFloat(a.variants[0].price)
        );
        break;

      default:
        return;

    }

    currentPageMap[handle] = 1;
    renderPage(tabContent, handle, 1);
    dropdown.classList.remove("open");

  });

  /* ======================
     RESIZE HANDLER
  ====================== */

  let resizeTimer;

  window.addEventListener("resize", function () {

    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(() => {

      document
        .querySelectorAll(".combo-tab-content[data-loaded='true']")
        .forEach(tabContent => {

          const handle = tabContent.dataset.handle;
          if (!handle || !allProductsCache[handle]) return;

          currentPageMap[handle] = 1;
          renderPage(tabContent, handle, 1);

        });

    }, 300);

  });

}); // end DOMContentLoaded